var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconBikingColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M5.625 18.75c0 .375-.25.625-.625.625s-.625-.25-.625-.625.25-.625.625-.625.625.25.625.625zm15 0c0 .375-.25.625-.625.625s-.625-.25-.625-.625.25-.625.625-.625.625.25.625.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA57",
    d: "M22.188 8.75h-3.875L16 5.5c0-.063-.063-.125-.063-.125-.687-1-2-1.25-3.062-.625l-5 3.75c-1 .688-1.25 2-.625 3.063.125.187.313.374.438.5l.062.062.188.125c.062 0 .062.063.125.063l3.687 2.062-.5 4.875c-.063.688.438 1.313 1.125 1.375h.125c.625 0 1.188-.5 1.25-1.125l.625-5.625a1.15 1.15 0 00-.5-1.125l-2.188-1.688 3.5-2.624L17 10.25c.188.25.438.375.75.375h4.375c.5 0 .938-.438.938-.938 0-.5-.375-.937-.875-.937zm-3.75-7.5c1.187 0 2.187 1 2.187 2.188 0 1.187-1 2.187-2.188 2.187-1.187 0-2.187-1-2.187-2.188 0-1.187 1-2.187 2.188-2.187"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M5 23.75c-2.75 0-5-2.25-5-5s2.25-5 5-5 5 2.25 5 5-2.25 5-5 5zM5 15a3.761 3.761 0 00-3.75 3.75A3.761 3.761 0 005 22.5a3.761 3.761 0 003.75-3.75A3.761 3.761 0 005 15zm15 8.75c-2.75 0-5-2.25-5-5s2.25-5 5-5 5 2.25 5 5-2.25 5-5 5zM20 15a3.761 3.761 0 00-3.75 3.75A3.761 3.761 0 0020 22.5a3.761 3.761 0 003.75-3.75A3.761 3.761 0 0020 15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D4C5C",
    d: "M11.688 11.063L7.812 8.5c-1 .688-1.25 2-.625 3.063.125.187.313.374.438.5l.063.062.187.125c.063 0 .063.063.125.063l3.438 1.937 2.374-1.438-.062-.062-2.063-1.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9575CD",
    d: "M15.938 5.5c0-.063-.063-.125-.063-.125-.688-1-2-1.25-3.063-.625l-5 3.75 3.875 2.563 3.5-2.626 1.626 1.625V10l1.375-1.375-2.25-3.125z"
  }))));
}

export default SvgCommonIconBikingColor;